<template>
  <div>
    <v-row justify="space-around" class="ma-0">
      <v-col align="center">
        <v-row justify="center">
          <span
            class="dot"
            id="edit-event-main-color-button"
            @click="
              colorPickerDialog = true
            "
            :style="'background-color: ' + eventStyle.mainColor"
          ></span>
        </v-row>
        <v-row justify="center"> {{ $t('EVENTFORM.form.main_color') }} </v-row>
      </v-col>
      <v-col align="center">
        <v-row justify="center">
          <v-icon
            id="edit-event-icon-button"
            @click="iconSelectionDialog = true"
          >
            {{ eventStyle.icon }}
          </v-icon>
        </v-row>
        <v-row justify="center"> {{ $t('EVENTFORM.form.event_icon') }} </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="colorPickerDialog" max-width="380" persistent>
      <v-card>
        <v-container>
          <v-row justify="center">
            <v-color-picker
              id="event-color-input"
              class="ma-2"
              v-model="color"
            ></v-color-picker>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            class="red--text"
            @click="colorPickerDialog = false"
            id="event-color-cancel-button"
          >
            {{ $t('EVENTFORM.form.cancel') }}
          </v-btn>

          <v-btn
            depressed
            id="event-color-save-input"
            color="green"
            class="white--text"
            @click="setColor()"
          >
            {{ $t('EVENTFORM.form.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="iconSelectionDialog" max-width="650" persistent>
      <v-card>
        <v-btn-toggle
          v-model="toggle_exclusive"
          mandatory
          id="event-icon-select"
        >
          <v-container>
            <v-row class="ma-0">
              <v-col
                v-for="(icon, i) in eventIcons"
                :key="i"
                cols="1"
                class="mx-1"
              >
                <v-btn text @click="iconKey = icon">
                  <v-icon>{{ icon }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-btn-toggle>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            class="red--text"
            @click="dismissIcon"
            id="event-icon-cancel-button"
          >
            {{ $t('EVENTFORM.form.cancel') }}
          </v-btn>

          <v-btn
            depressed
            color="green"
            class="white--text"
            id="event-icon-save-input"
            @click="selectIcon"
          >
            {{ $t('EVENTFORM.form.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiSilverwareForkKnife,
  mdiAccountVoice,
  mdiAccountGroup,
  mdiForum,
  mdiMessageVideo,
  mdiBookOpenVariant,
  mdiCalendar,
} from "@mdi/js";

export default {
  props: ["eventStyle"],
  data() {
    return {
      iconSelectionDialog: false,
      colorPickerDialog: false,
      color: "#1C00FF",
      selectedIcon: "",
      iconKey: "",
      eventIcons: [
        mdiCalendar,
        mdiSilverwareForkKnife,
        mdiAccountVoice,
        mdiAccountGroup,
        mdiForum,
        mdiMessageVideo,
        mdiBookOpenVariant,
      ],
    };
  },
  computed: {
    toggle_exclusive: {
      set: function (newValue) {
        return newValue
      },
      get: function () {
        return this.eventIcons.findIndex((i) => i == this.iconKey) || 0;
      },
    },
  },
  methods: {
    selectIcon() {
      this.iconSelectionDialog = false;
      if (this.iconKey != "" && this.iconKey != null) {
        this.eventStyle.icon = this.iconKey;
      }
    },
    dismissIcon() {
      this.iconSelectionDialog = false;
      if (this.iconKey != "" && this.iconKey != null) {
        this.iconKey = "";
      }
    },
    setColor() {
      this.colorPickerDialog = false;
      this.eventStyle.mainColor = this.color;
    },
  },
  mounted() {
    if (this.eventStyle && this.eventStyle.mainColor) {
      this.color = this.eventStyle.mainColor;
    }

    if (this.eventStyle && this.eventStyle.icon) {
      this.iconKey = this.eventStyle.icon;
    }
  }
};
</script>

<style scoped>
.dot {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
}
.title-custom {
  font-size: 28px;
  font-weight: 300;
  margin: 3% 0% 1% 1%;
}
</style>